import { MessageMedium } from 'constants/messageMediums';
import { FunctionComponent, useState } from 'react';
import { CreateCampaignContext, CreateCampaignState } from './CreateCampaignContext';

export const CreateCampaignContextProvider: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [messageMedium, setMessageMedium] = useState(MessageMedium.Email);
  const [hasApprovedBusinessTemplates, setHasApprovedBusinessTemplates] = useState(false);

  const context: CreateCampaignState = {
    messageMedium,
    setMessageMedium,
    hasApprovedBusinessTemplates,
    setHasApprovedBusinessTemplates,
  };

  return (
    <CreateCampaignContext.Provider value={context}>{children}</CreateCampaignContext.Provider>
  );
};
